import React, { Component } from 'react';

class Home extends Component {
  render() {
    return (
      <div className="Home">
        Apps
        <ul>
          <li style={{ textDecoration: 'line-through' }}>CHEN Submission Form</li>
          <li style={{ textDecoration: 'line-through' }}>Newsletter Signup</li>
        </ul>
      </div>
    );
  }
}

export default Home;
